import { render } from "./Customers.vue?vue&type=template&id=3199cd94&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=ts"
export * from "./Customers.vue?vue&type=script&lang=ts"

import "./Customers.vue?vue&type=style&index=0&id=3199cd94&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3199cd94"

export default script